import React, { useEffect, useState } from "react";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { useSearchSortHoaFeeTypeApiQuery, useUpdateSortHoaFeeTypeApiMutation } from "../sortHoaFeeType";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

interface FeeType {
    id: string;
    feeType: string;
    sortOrder: number;
}

const SortHoaFeeType = () => {
    const { data: enums } = useGetEnumsQuery("");
    const { data: feeTypes, isFetching } = useSearchSortHoaFeeTypeApiQuery("");
    const [updateSortHoaFeeTypeApi] = useUpdateSortHoaFeeTypeApiMutation();

    const [sortedItems, setSortedItems] = useState<FeeType[]>([]);

    useEffect(() => {
        if (feeTypes) {
            setSortedItems(feeTypes);
        }
    }, [feeTypes]);

     useEffect(() => {
            document.title = 'Fee Sorting';
        
        }, []);

    const handleDragEnd = (result: any) => {
        if (!result.destination) return;

        const reorderedItems = Array.from(sortedItems);
        const [movedItem] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, movedItem);

        setSortedItems(reorderedItems);

        // Update API with new order
        const newSortedIds = reorderedItems.map((item) => item.id);
        updateSortHoaFeeTypeApi(newSortedIds);
    };

    return (
        <div className="m-0 p-0">
            <section id="content-wrapper">
                <div className="row">
                    <div className="col-lg-12 px-4 py-2">
                        <Breadcrumb
                            crumbs={[
                                { content: "Home", url: "/home" },
                                { content: "Sort HOA Fee Type", url: "" },
                            ]}
                        />

                        <div className="table_data mt-2">
                            {hasPermission(["FEESORT-V"]) && (
                                <DragDropContext onDragEnd={handleDragEnd}>
                                        <table className=" p-3 w-full   ">
                                            <thead className="bg-highlight-0 text-text-0">
                                            <tr>
                                                <th className="text-left px-4 py-3">Fee Type</th>
                                            </tr>
                                            </thead>
                                            {hasPermission(["FEESORT-U"]) ? (
                                                <Droppable droppableId="droppable">
                                                    {(provided) => (
                                                        <tbody
                                                            {...provided.droppableProps}
                                                            ref={provided.innerRef}
                                                        >
                                                        {sortedItems.length > 0 &&
                                                            sortedItems.map((row, index) => (
                                                                <Draggable key={row.id} draggableId={row.id} index={index}>
                                                                    {(provided) => (
                                                                        <tr
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                            className="odd:bg-text-1 hover:bg-text-1 transition cursor-pointer"
                                                                        >
                                                                            <td className="px-4 py-3 flex items-center">
                                                                                <i className="fas fa-grip-vertical mr-3 text-gray-500" />
                                                                                {enums?.["FeeType"]?.find((curEnum: any) => curEnum.constant === row.feeType)?.value || "Unknown"}
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                        {provided.placeholder}
                                                        </tbody>
                                                    )}
                                                </Droppable>
                                            ) : (
                                                <tbody className="divide-y divide-gray-200">
                                                {sortedItems.length > 0 &&
                                                    sortedItems.map((row) => (
                                                        <tr key={row.id} className="odd:bg-gray-100 hover:bg-gray-200 transition">
                                                            <td className="px-4 py-3">{row.feeType}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            )}
                                        </table>
                                </DragDropContext>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default SortHoaFeeType;
